/* eslint-disable react/prop-types */
import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import { Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { useIntl } from 'react-intl';

export default function Loading({ open, loadingCounter }) {
  const intl = useIntl();

  return (
    <div>
      <Backdrop sx={{ color: '#26a69a', zIndex: 10000 }} open={open} loadingCounter={loadingCounter}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <CircularProgress color="inherit" />
          <Typography
            variant="subtitle2"
            gutterBottom
            component="div"
            sx={{ color: '#ffffff' }}
            style={{ padding: '8px' }}
          >
            {`${intl.messages.RUNNING_REQUESTS}: ${loadingCounter}`}
          </Typography>
        </div>
      </Backdrop>
    </div>
  );
}
